import PassengerDetail from '@/views/PassengerDetail/index.vue'

const PassengerDetailRouter = {
  path: '/passenger-detail',
  name: 'PassengerDetail',
  component: PassengerDetail,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default PassengerDetailRouter
